export default "__VITE_ASSET__078a40bd__"